<script>
    export let value;
    export let options = [];

    export let readonly;

    function checkOption(opt) {
        for (let val of value) {
            if (opt.id == val.id) {
                return true;
            }
        }

        return false;
    }


    function toggleOption(opt) {
        if (checkOption(opt)) {
            value = value.filter(t => t.id != opt.id);
        } else {
            value = [...value, opt];
        }
    }
</script>

{#if readonly}
    <div class="tags are-medium">
        {#each value as tag}
            <span class="tag is-{tag.color_class}">{tag.name}</span>
        {/each}
    </div>
{:else}
    <div class="tags are-medium">
        {#each options as option (option.id)}
            <span class="pointer tag is-{option.color_class}" on:click={() => toggleOption(option)} class:is-light={!checkOption(option, value)}>
                {option.name}
            </span>
        {/each}
    </div>
{/if}